import { render } from "./ReplyWidget.vue?vue&type=template&id=2ca40ac2"
import script from "./ReplyWidget.vue?vue&type=script&lang=js"
export * from "./ReplyWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__